import { mixpanel } from '@fiverr-private/obs';

const PAGE_NAME = 'Vibe coding LP';
const FLOW_NAME = 'Vibe coding';

const WEB_PLATFORMS = {
    default: 'mobile',
    sm: 'mobile',
    md: 'tablet',
    lg: 'tablet',
    xl: 'desktop',
    xxl: 'desktop',
};
type Breakpoint = keyof typeof WEB_PLATFORMS;

export const reportClickedOnExpertCardEvent = (sellerId: number, sellerName: string, pageName: string) =>
    mixpanel.track('Clicked on Expert Card', {
        'Page Name': pageName,
        'Seller Id': sellerId,
        'Seller Username': sellerName,
    });

export const reportIdentificationCompletedEvent = () =>
    mixpanel.track('Identification - Completed', {
        'Page Name': PAGE_NAME,
    });

export const reportClickedOnSendBriefEvent = (sellerId: number) =>
    mixpanel.track('Vibe coding - Clicked on send brief', {
        'Page Name': PAGE_NAME,
        'Seller Id': sellerId,
    });

export const reportViewedPageEvent = (utmCampaign: string, utmSource: string, breakpoint: Breakpoint) =>
    mixpanel.track('Viewed page', {
        'Page Name': PAGE_NAME,
        'UTM Campaign': utmCampaign,
        'UTM Source': utmSource,
        Platform: WEB_PLATFORMS[breakpoint],
    });

export const reportVerticalFlowComponentImpressionEvent = (
    componentName: string,
    breakpoint: Breakpoint,
    locale: string,
    country: string
) =>
    mixpanel.track('Vertical flow - Component Imp', {
        'Component name': componentName,
        'Flow Name': FLOW_NAME,
        Platform: WEB_PLATFORMS[breakpoint],
        'User Locale': locale,
        Country: country,
    });

export const reportVerticalFlowComponentClickEvent = (
    componentName: string,
    breakpoint: Breakpoint,
    locale: string,
    country: string
) =>
    mixpanel.track('Vertical flow - Component Click', {
        'Component name': componentName,
        'Flow Name': FLOW_NAME,
        Platform: WEB_PLATFORMS[breakpoint],
        'User Locale': locale,
        Country: country,
    });

export const reportVerticalFlowButtonClickEvent = (
    buttonName: string,
    breakpoint: Breakpoint,
    cannedMessageName?: string
) =>
    mixpanel.track('Vertical flow - Button Click', {
        'Flow Name': FLOW_NAME,
        'Button name': buttonName,
        Platform: WEB_PLATFORMS[breakpoint],
        'Canned message name': cannedMessageName || 'None',
    });
